export default {
  UNAVAILABLEOVERLAP: {
    TITLE: `Conflits entre l'horaire et les disponibilités`,
    SUMMARY: ``
  },
  LEAVEOVERLAPPING: {
    TITLE: `Conflits entre l'horaire et les absences`,
    SUMMARY: ``
  },
  VACATIONOVERLAPPING: {
    TITLE: `Conflits entre l'horaire et les congés`,
    SUMMARY: ``
  }
}
